import { BoxProps, ColorOptions, TextNewProps } from '@jfs/ui-new'
import { TextStyle, ViewStyle } from 'react-native'

export const styles = () => ({
  container: {
    // ...Theme.shadowStyle,
    backgroundColor: 'WHITE',
    flex: 1,
  } as BoxProps,
  containerWeb: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: '#0000001F',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#00000014',
    zIndex: 10,
    paddingHorizontal: 16,
    paddingBottom: 16,
    backgroundColor: 'WHITE',
    justifyContent: 'space-between',
    flexGrow: 1,
  } as unknown as BoxProps,
  tabbar: {
    backgroundColor: 'WHITE',
    marginRight: 'auto',
    width: '100%',
    // pl: 10,
    height: 48,
  } as BoxProps,
  tabbarweb: {
    backgroundColor: 'WHITE',
    paddingTop: 16,
    alignItems: 'flex-start',
    // paddingBottom: 8,
  } as BoxProps,
  errorView: {
    width: '100%',
    textAlign: 'center',
    margin: 8,
    color: 'red',
  } as TextStyle,
  tableContainer: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 3,
    shadowColor: '#0000001F' as ColorOptions,
    flexGrow: 1,
  } as BoxProps,
  emptyContainer: {
    flex: 1,
    flexGrow: 1,
  } as BoxProps,
  recentTransactionText: {
    color: 'DARK_GREY',
    fontSize: 'SMALL',
    type: 'body12',
    fontWeight: 'FONT_WEIGHT_BOLD',
  } as TextNewProps,
  contentContainerStyle: {
    flexGrow: 1,
  } as ViewStyle,
  stickyHeader: {
    position: 'sticky',
    top: 0,
    paddingVertical: 16,
    backgroundColor: 'white',
    zIndex: 100,
  } as unknown as BoxProps,
  scrollView: ({ loadingState }: any) => ({ backgroundColor: loadingState ? 'transparent' : 'white' } as ViewStyle),
})
